import {useForm} from '@tanstack/react-form';
import {EvInputField} from '../form/EvInputField';
import {EvButton} from '../form/EvButton';
import {useManualPriceUpdateMutation} from './useManualPriceUpdateMutation';
import {NumberHelper} from '../../helper/number-helper';
import {ManualPriceUpdateProps} from './manual-price-update.model';
import {ManualPriceIncreasePreview} from './manual-price-increase-preview';

export function ManualPriceIncreaseForm(props: ManualPriceUpdateProps) {
  const mutation = useManualPriceUpdateMutation(props);
  const form = useForm({
    defaultValues: {
      percent: '',
    },
    onSubmit: ({formApi}) => {
      mutation.mutate(
        {percent: NumberHelper.saveParseFloat(formApi.state.values.percent)},
        () => props.onUpdated(),
      );
    },
  });

  return <form onSubmit={async e => {
    e.preventDefault();
    await form.handleSubmit(e);
  }}>
    {props.labelButton === 'Preis erhöhen' &&
      <form.Subscribe selector={f => [f.values.percent]}>
        {([percent]) =>
          <ManualPriceIncreasePreview price={props.price} percentString={percent}/>
        }
      </form.Subscribe>
    }

    <div className="modal-body">
      <div className="p-2">
        <div><label htmlFor="percent">Prozentuale Erhöhung</label></div>
        <div>
          <form.Field name="percent">
            {field =>
              <EvInputField type="text"
                            autoFocus={true}
                            field={field}
                            errors={mutation.error?.validation?.errors ?? {}}
                            title={!mutation.error?.validation?.errors?.percent ? '' : 'Muss Dezimalzahl sein'}/>
            }
          </form.Field>
        </div>
      </div>
    </div>

    <div className="modal-footer">
      <EvButton className="w-full"
                variant="success"
                size="sm"
                type="submit"
                disabled={mutation.isPending}>
        {props.labelButton}
      </EvButton>
    </div>
  </form>;
}
